module.exports = __webpack_public_path__ + "media/laser_shoot.6de73849.wav";